import { API_ENDPOINTS } from "./config";

const BOOK_APPOINTMENT_API = API_ENDPOINTS.bookAppointments;

/**
 * POST /api/v1/book_appointments
 * @param {{
 *   name: string,
 *   email: string,
 *   phone_number: string,
 *   service_id: number,
 *   appointment_location: string,
 *   date: string,
 *   time: string,
 * }} payload
 */
export const createBookAppointment = async (payload) => {
  const response = await fetch(BOOK_APPOINTMENT_API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ book_appointment: payload }),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const message =
      data?.message ||
      data?.error ||
      (Array.isArray(data?.errors) ? data.errors.join(", ") : null) ||
      `Failed to book appointment (${response.status})`;
    throw new Error(message);
  }

  return data;
};
